export const environment = {
  production: false,
  developer: 'Haulmatic',
  version: 2.2,
  haulmatic: {
    baseUrl: 'https://dev.api.swyftflo.ai',
    apiGateway: 'https://dev.api.swyftflo.ai' + '/api/graphql-gateway',
    //apiGateway: 'http://localhost:8081' + '/api/graphql-gateway',
  },
  google: {
    apiKey: 'AIzaSyBhHe3jP_tu9VkVCGZxVAVZW6bfWzcCiUY',
    mapApiKey: 'AIzaSyALAfOgB1fbWDrH7Qci0qZ_ebI4He92O14',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyDJb8Q1P1_CExeYZQFWL5jiJzeqfj8WtxY',
    authDomain: 'hmt-platform-dev.firebaseapp.com',
    projectId: 'hmt-platform-dev',
    storageBucket: 'hmt-platform-dev.appspot.com',
    messagingSenderId: '234371977444',
    appId: '1:234371977444:web:2b04453678d2ae745f5cf1',
    measurementId: 'G-D2HJSTKN0D',
  },

  appScripts: {
    marketingLeads:
      'https://script.google.com/macros/s/AKfycbxSwLRgxUT5Qqeeuz8oeux4X_CsDUV5oR30d_7oPAQ0UQGrWJg7DXNjEnvcmWYlgxO4Mw/exec',
  },
};
